import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Workzone = {
  id: PropTypes.number,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const WorkzoneShape = PropTypes.shape(Workzone);
export const WorkzoneExact = PropTypes.exact(Workzone);
